export class CentroCustoModel {
  id: number;
  descricao: String;
}



// WEBPACK FOOTER //
// /app/src/app/model/cliente/centrocusto.model.ts